import PropTypes from "prop-types"
import Paper from 'material-ui/Paper'
import Divisor from '../../../../components/card/body-card/card-divisor'
import intl from 'react-intl-universal'
import StatusCard from '../../../../components/card/body-card/status-card'
import * as S from './styled'
import { formatNumber, formatWithoutLeadingZeros } from 'utils/format'
import { getCardName } from '../../utils'
import { parseFloatByLocale } from "locales/utils";
import Feature from 'components/feature'
import { TextSpan } from 'components/text-label'
import moment from 'moment'
import { formatHourTimeOrDefault } from 'utils/delivery-time'
import { WarningIcon } from 'components/icons/icn-warning-status-projects.icon'
import Button from "components/button"

const CardOrderSuggestionIntoLoadComposition = ({ data, materialNumbers, handleClick, openModal, codeDescription }) => {
  const tipo = {
    Etapa: 1,
    Prioridade: data.IdPedido ? 1 : 0,
    Titulo: getCardName(data)
  }

  return (
    <S.Wrapper isDeleted={data.IsDeleted}>
      <Paper zDepth={1} className='card-shop-mester' style={{ height: `250px` }}>
        <div className='card-click-area' data-testid={`card-order-code-${data.IdPedido}`}>
          {materialNumbers.filter(x => x == data.NumeroMaterial).length > 1 &&
            <div className='warning-waiting-return'>
              <WarningIcon width='10px' height='10px' color='#AE00FF' />{intl.get('commons.duplicatedMaterial')}
            </div>
          }
          <div className='header-card'>
            <StatusCard
              tipo={tipo}
              material={formatWithoutLeadingZeros(data.Material)}
            />
          </div>
          <Divisor />
          <div className='body-card'>
            <div className='card-label'>
              <TextSpan>{intl.get('loadComposition.building.orderAmmount')}</TextSpan>
              <TextSpan title={`${formatNumber(data.Quantidade)}${data.QuantidadeUnidadeMedida}-${data.TotalPallets}${data.LotesUnidadeMedida}`}
                className='description-bold' data-testid={`order-code-value-${data.IdPedido}`}>
                {formatNumber(data.Quantidade)}{data.QuantidadeUnidadeMedida} {` - `}
                <TextSpan className='description-bold' style={{ color: 'var(--color-action-default)' }}>
                  {Math.ceil(parseFloatByLocale(data.TotalPallets))}{data.LotesUnidadeMedida}
                </TextSpan>
              </TextSpan>
            </div>
            <Feature validation={!!data.EstoqueAtual}>
              <div className='card-label'>
                <TextSpan>{intl.get('stocks.timeline.currentInventory')}</TextSpan>
                <TextSpan className='description-bold' data-testid={`order-current-stock-code-${data.IdPedido}`}> {formatNumber(data.EstoqueAtual)}{data.EstoqueAtualUnidadeMedida}</TextSpan>
              </div>
            </Feature>
          </div>
          <div>
            <Divisor />
            <div className='body-card'>
              {data.CodigoPedidoSap &&
                <div className='card-label'>
                  <TextSpan>{codeDescription}</TextSpan>
                  <TextSpan className='description-bold' data-testid={`order-wms-code-${data.IdPedido}`}>{data.CodigoPedidoSap}</TextSpan>
                </div>
              }
              <div className='card-label'>
                <TextSpan>{intl.get('commons.originalDeliveryTime')}</TextSpan>
                <TextSpan className='description-bold'>{formatHourTimeOrDefault(data.DeliveryTime)}</TextSpan>
              </div>
            </div>
            <Divisor />
            <div className='body-card'>
              <div className='card-label'>
                <TextSpan>{intl.get('commons.colDate')}</TextSpan>
                <TextSpan className='description-bold'> {moment(data.DataColeta).format("L")}</TextSpan>
              </div>
              <div className='card-label'>
                <TextSpan>{intl.get('commons.deliveryDate')}</TextSpan>
                <TextSpan className='description-bold'> {moment(data.DataEntrega).format("L")} </TextSpan>
              </div>
            </div>
            <div className='body-card'>
              <S.ActionsWrapper className='card-label'>
                <Feature validation={!data.IsNew}>
                  <Button
                    buttonType='primary'
                    value={intl.get('stocks.timeline.editOrder')}
                    onClick={openModal}
                    className={`edit-card-${data.IdPedido}`}
                    style={{ width: '112px', height: '26px', fontSize: '10px' }}
                  />
                </Feature>
                <Button
                  className={`remove-card-${data.IdPedido}`}
                  buttonType='default'
                  value={intl.get('loadComposition.building.removeLoad')}
                  onClick={handleClick}
                  style={{ width: '112px', height: '26px', fontSize: '10px', marginLeft: '6px' }}
                />
              </S.ActionsWrapper >
            </div>
          </div >
        </div >
      </Paper >
    </S.Wrapper >
  )
}

CardOrderSuggestionIntoLoadComposition.propTypes = {
  codeDescription: PropTypes.any.isRequired,
  data: PropTypes.shape({
    CodigoPedidoSap: PropTypes.any,
    DataColeta: PropTypes.any,
    DataEntrega: PropTypes.any,
    DeliveryTime: PropTypes.any,
    EstoqueAtual: PropTypes.any,
    EstoqueAtualUnidadeMedida: PropTypes.any,
    IdPedido: PropTypes.any,
    IsDeleted: PropTypes.any,
    IsNew: PropTypes.any,
    LotesUnidadeMedida: PropTypes.any,
    Material: PropTypes.any,
    NumeroMaterial: PropTypes.any,
    Quantidade: PropTypes.any,
    QuantidadeUnidadeMedida: PropTypes.any,
    TotalPallets: PropTypes.any
  }).isRequired,
  handleClick: PropTypes.any.isRequired,
  materialNumbers: PropTypes.shape({
    filter: PropTypes.func
  }).isRequired,
  openModal: PropTypes.any.isRequired
}

export default CardOrderSuggestionIntoLoadComposition
